/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */
import { BlogHomeListElementDataType } from '@/components/sections/builder/elements/body/blog-home/type';
import { BlogPostListElementDataType } from '@/components/sections/builder/elements/body/blog-post/type';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import { removeHTMLTags, truncateText } from '@/lib/utils';
import { ElementType, ThemeType } from '@/stores/builder';
import clsx from 'clsx';
import { format } from 'date-fns';
import Link from 'next/link';

type BlogType = {
  id: string;
  image_banner: string;
  slug: string;
  title: string;
  content: string;
  author: string;
  created_at: string;
};

type DetailContentType = {
  data: BlogHomeListElementDataType | BlogPostListElementDataType;
  blog: BlogType;
  element: ElementType;
  index: number;
  category: string;
  builder: {
    theme: ThemeType;
    setTheme: (theme: ThemeType) => void;
  };
};

export default function DetailContent({
  data,
  blog,
  element,
  index,
  category,
  builder,
}: DetailContentType) {
  return (
    <article
      className='post-gap'
      data-animation='true'
      data-animation-group={`blog-item-${element.id}`}
      {...getOverrideAnimationParams(data.animation, index)}
    >
      <div
        className={clsx(
          'theme_animation_card_hover font_color flex flex-col justify-between overflow-hidden rounded-none',
          data.showShadow && 'shadow-md'
        )}
      >
        <div className=''>
          {data.showImage && blog.image_banner && (
            <div className='image_padding'>
              <img
                className='aspect-[3/2] w-full object-cover'
                src={blog.image_banner}
                alt='Jese Leos avatar'
              />
            </div>
          )}
          <div className='pb-1 pt-4 '>
            <h2 className='mb-2 '>
              <Link href={`/blogs/${category}/${blog.slug}`}>
                {truncateText(blog.title, builder.theme?.blogCard?.limitCharacters as number)}
              </Link>
            </h2>
            {data.showContent && (
              <p className='mb-5 line-clamp-3 font-light'>
                {removeHTMLTags(blog.content || 'No description available')}
              </p>
            )}
          </div>
        </div>
        <div>
          <div className='flex items-center justify-between p-4 pt-0'>
            {data.showAuthor && (
              <div className='flex items-center space-x-2'>
                {/* temporary hide */}
                {/* <img
            className='rounded-full h-7 w-7'
            src='https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/jese-leos.png'
            alt='Jese Leos avatar'
          /> */}
                <span className='font-medium'>{blog.author}</span>
              </div>
            )}
            {data.showDate && <span>{format(new Date(blog.created_at), 'MMMM dd, yyyy')}</span>}
          </div>
        </div>
      </div>
    </article>
  );
}
